/* BERK Produktseite (Vorlage product.berk) – Varianten, Wunschtermin, Standzeit, Warenkorb */
(function () {
  'use strict';

  var WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var WDL = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var MON = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var EUR = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function money(cents) { return EUR.format(cents / 100); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function dmy(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function dm(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.'; }
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function today() { var t = new Date(); return new Date(t.getFullYear(), t.getMonth(), t.getDate()); }

  /* Ostersonntag (gregorianisch) – Grundlage der beweglichen Feiertage */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mo - 1, da);
  }
  var holidayCache = {};
  /* Gesetzliche Feiertage NRW */
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var e = easter(y), set = {};
    [new Date(y, 0, 1), addDays(e, -2), addDays(e, 1), new Date(y, 4, 1), addDays(e, 39), addDays(e, 50),
      addDays(e, 60), new Date(y, 9, 3), new Date(y, 10, 1), new Date(y, 11, 25), new Date(y, 11, 26), new Date(y, 11, 24), new Date(y, 11, 31)]
      .forEach(function (d) { set[key(d)] = true; });
    holidayCache[y] = set;
    return set;
  }

  function BerkPdp(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-berk-data]');
    if (!dataEl) return;
    this.d = JSON.parse(dataEl.textContent);
    this.form = root.querySelector('form[action*="/cart/add"]');
    this.selected = null;
    this.weeks = 0;
    this.calMonth = null;
    this.initVariants();
    this.initQty();
    this.initGallery();
    if (this.d.needsDate) this.initDate();
    this.initStz();
    this.initStar();
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.update();
  }

  /* Sternchen „Keine Gewichtsdeckelung*“ → Erklärung unter „So füllen Sie richtig“ öffnen */
  BerkPdp.prototype.initStar = function () {
    var root = this.root;
    root.querySelectorAll('[data-berk-star]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = root.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.open = true;
        target.scrollIntoView({ block: 'center', behavior: document.hidden ? 'auto' : 'smooth' });
        var s = target.querySelector('summary');
        if (s) s.focus({ preventScroll: true });
      });
    });
  };

  /* ---------- Varianten ---------- */
  BerkPdp.prototype.variant = function () {
    var id = this.selected, list = this.d.variants;
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  };
  BerkPdp.prototype.initVariants = function () {
    var self = this;
    var checked = this.form.querySelector('input[name="id"]:checked') || this.form.querySelector('input[name="id"]');
    this.selected = checked ? parseInt(checked.value, 10) : this.d.variants[0].id;
    this.form.querySelectorAll('input[type="radio"][name="id"]').forEach(function (r) {
      r.addEventListener('change', function () {
        self.selected = parseInt(r.value, 10);
        var v = self.variant();
        self.update();
        if (v.media >= 0) self.showMedia(v.media, true);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      });
    });
  };

  /* ---------- Menge ---------- */
  BerkPdp.prototype.initQty = function () {
    var self = this;
    this.qtyInput = this.root.querySelector('[data-berk-qty]');
    if (!this.qtyInput) return;
    this.root.querySelectorAll('[data-berk-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(self.qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-berk-qty-step'), 10);
        self.qtyInput.value = Math.max(1, Math.min(20, n));
        self.update();
      });
    });
    this.qtyInput.addEventListener('change', function () {
      self.qtyInput.value = Math.max(1, Math.min(20, parseInt(self.qtyInput.value, 10) || 1));
      self.update();
    });
  };
  BerkPdp.prototype.qty = function () { return this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1; };

  /* ---------- Galerie ---------- */
  BerkPdp.prototype.initGallery = function () {
    var self = this;
    this.strip = this.root.querySelector('[data-berk-strip]');
    if (!this.strip) return;
    this.slides = Array.prototype.slice.call(this.strip.querySelectorAll('[data-berk-slide]'));
    this.lightbox = this.root.querySelector('[data-berk-lightbox]');
    this.slides.forEach(function (s, i) {
      s.addEventListener('click', function () { self.openLightbox(i); });
    });
    if (this.lightbox) {
      this.lightbox.querySelector('[data-berk-lb-close]').addEventListener('click', function () { self.lightbox.close(); });
      this.lightbox.querySelectorAll('[data-berk-lb-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = self.slides.length;
          self.openLightbox((self.lbIndex + parseInt(b.getAttribute('data-berk-lb-step'), 10) + n) % n);
        });
      });
      this.lightbox.addEventListener('click', function (e) { if (e.target === self.lightbox) self.lightbox.close(); });
    }
    this.mediaIndex = 0;
    if (window.ResizeObserver) {
      new ResizeObserver(function () { self.strip.scrollLeft = self.mediaIndex * self.strip.clientWidth; }).observe(this.strip);
    }
    var v = this.variant();
    if (v.media > 0) this.showMedia(v.media, false);
  };
  /* Bildwechsel nur über die Variantenwahl (Wischen ist per CSS gesperrt) */
  BerkPdp.prototype.showMedia = function (i, smooth) {
    if (!this.strip || i < 0 || i >= this.slides.length) return;
    this.mediaIndex = i;
    this.strip.scrollTo({ left: i * this.strip.clientWidth, behavior: smooth && !document.hidden ? 'smooth' : 'auto' });
  };
  BerkPdp.prototype.openLightbox = function (i) {
    if (!this.lightbox || !this.lightbox.showModal) return;
    var s = this.slides[i];
    this.lbIndex = i;
    var img = this.lightbox.querySelector('img');
    img.src = s.getAttribute('data-full');
    img.alt = s.getAttribute('data-alt') || '';
    this.lightbox.querySelector('[data-berk-lb-cap]').textContent = (i + 1) + ' / ' + this.slides.length;
    if (!this.lightbox.open) this.lightbox.showModal();
  };

  /* ---------- Wunschtermin ---------- */
  BerkPdp.prototype.isDeliveryDay = function (d) {
    var g = d.getDay();
    if (g === 0 || g === 6) return false;
    if (this.d.blockHolidays && holidays(d.getFullYear())[key(d)]) return false;
    return true;
  };
  BerkPdp.prototype.minDate = function () {
    var d = today(), n = 0, lead = this.d.leadDays || 0;
    while (n < lead) { d = addDays(d, 1); if (this.isDeliveryDay(d)) n++; }
    var guard = 0;
    while (!this.isDeliveryDay(d) && guard++ < 30) d = addDays(d, 1);
    return d;
  };
  BerkPdp.prototype.initDate = function () {
    var self = this;
    this.dateWrap = this.root.querySelector('[data-berk-date]');
    this.dateInput = this.root.querySelector('[data-berk-date-input]');
    this.dateAux = this.root.querySelector('[data-berk-date-aux]');
    this.chipsEl = this.root.querySelector('[data-berk-chips]');
    this.cal = this.root.querySelector('[data-berk-cal]');
    this.dateValue = null;
    this.min = this.minDate();
    this.renderChips();
    if (this.cal) {
      this.cal.querySelector('[data-berk-cal-prev]').addEventListener('click', function () { self.calMonth = addMonth(self.calMonth, -1); self.renderCal(); });
      this.cal.querySelector('[data-berk-cal-next]').addEventListener('click', function () { self.calMonth = addMonth(self.calMonth, 1); self.renderCal(); });
      this.cal.querySelector('[data-berk-cal-close]').addEventListener('click', function () { self.cal.close(); });
      this.cal.addEventListener('click', function (e) { if (e.target === self.cal) self.cal.close(); });
    }
    function addMonth(d, n) { return new Date(d.getFullYear(), d.getMonth() + n, 1); }
  };
  BerkPdp.prototype.renderChips = function () {
    var self = this, html = '', d = this.min, dates = [], guard = 0;
    while (dates.length < 4 && guard++ < 60) { if (this.isDeliveryDay(d)) dates.push(d); d = addDays(d, 1); }
    this.chipKeys = dates.map(key);
    dates.forEach(function (x) {
      var k = key(x), on = self.dateValue && key(self.dateValue) === k;
      html += '<button type="button" class="berk-chip" data-k="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + WDL[x.getDay()] + ', ' + dmy(x) + '">' +
        '<span class="berk-chip__wd">' + WD[x.getDay()] + '</span><span class="berk-chip__dm">' + dm(x) + '</span></button>';
    });
    var custom = this.dateValue && this.chipKeys.indexOf(key(this.dateValue)) < 0;
    html += '<button type="button" class="berk-chip" data-cal aria-pressed="' + (custom ? 'true' : 'false') + '" aria-label="Weitere Termine im Kalender wählen">' +
      (custom
        ? '<span class="berk-chip__wd">' + WD[this.dateValue.getDay()] + '</span><span class="berk-chip__dm">' + dm(this.dateValue) + '</span>'
        : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15.5"></rect><path d="M3.5 10h17M8 3v4M16 3v4"></path></svg><span class="berk-chip__wd">Mehr</span>') +
      '</button>';
    this.chipsEl.innerHTML = html;
    this.chipsEl.querySelectorAll('[data-k]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = b.getAttribute('data-k').split('-');
        self.setDate(new Date(+p[0], +p[1] - 1, +p[2]));
      });
    });
    this.chipsEl.querySelector('[data-cal]').addEventListener('click', function () { self.openCal(); });
  };
  BerkPdp.prototype.setDate = function (d) {
    this.dateValue = d;
    this.dateInput.value = dmy(d);
    this.dateError = false;
    this.renderChips();
    this.update();
  };
  BerkPdp.prototype.openCal = function () {
    if (!this.cal || !this.cal.showModal) return;
    var base = this.dateValue || this.min;
    this.calMonth = new Date(base.getFullYear(), base.getMonth(), 1);
    this.renderCal();
    this.cal.showModal();
  };
  BerkPdp.prototype.renderCal = function () {
    var self = this, m = this.calMonth, html = '';
    var first = new Date(this.min.getFullYear(), this.min.getMonth(), 1);
    var last = new Date(first.getFullYear(), first.getMonth() + 6, 1);
    this.cal.querySelector('[data-berk-cal-title]').textContent = MON[m.getMonth()] + ' ' + m.getFullYear();
    this.cal.querySelector('[data-berk-cal-prev]').disabled = m <= first;
    this.cal.querySelector('[data-berk-cal-next]').disabled = m >= last;
    var lead = (m.getDay() + 6) % 7;
    for (var i = 0; i < lead; i++) html += '<button type="button" class="berk-day berk-day--pad" disabled tabindex="-1" aria-hidden="true"></button>';
    var dim = new Date(m.getFullYear(), m.getMonth() + 1, 0).getDate();
    var sel = this.dateValue ? key(this.dateValue) : '';
    for (var dd = 1; dd <= dim; dd++) {
      var x = new Date(m.getFullYear(), m.getMonth(), dd), k = key(x);
      var ok = x >= this.min && this.isDeliveryDay(x);
      html += '<button type="button" class="berk-day" data-k="' + k + '"' + (ok ? '' : ' disabled') + ' aria-pressed="' + (k === sel ? 'true' : 'false') + '" aria-label="' + WDL[x.getDay()] + ', ' + dmy(x) + (ok ? '' : ' – nicht wählbar') + '">' + dd + '</button>';
    }
    var grid = this.cal.querySelector('[data-berk-cal-days]');
    grid.innerHTML = html;
    grid.querySelectorAll('[data-k]:not([disabled])').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = b.getAttribute('data-k').split('-');
        self.setDate(new Date(+p[0], +p[1] - 1, +p[2]));
        self.cal.close();
      });
    });
  };

  /* ---------- Standzeit ---------- */
  BerkPdp.prototype.stzVariant = function () {
    if (!this.d.stz) return null;
    return this.variant().abroll ? this.d.stz.abr : this.d.stz.abs;
  };
  BerkPdp.prototype.initStz = function () {
    var self = this;
    this.stzEl = this.root.querySelector('[data-berk-stz]');
    if (!this.stzEl) return;
    /* Keine kostenpflichtige Vorauswahl – auch nicht nach Neuladen (Browser stellen Formularzustände sonst wieder her) */
    var zero = this.stzEl.querySelector('input[name="berk-weeks"][value="0"]');
    if (zero) zero.checked = true;
    this.weeks = 0;
    this.stzEl.querySelectorAll('input[name="berk-weeks"]').forEach(function (r) {
      r.addEventListener('change', function () { self.weeks = parseInt(r.value, 10) || 0; self.update(); });
    });
    /* „Mehr“ wie beim Wunschtermin: öffnet ein Blatt mit längerer Standzeit */
    this.stzMore = this.stzEl.querySelector('[data-berk-stz-more]');
    this.stzSheet = this.stzEl.querySelector('[data-berk-stz-sheet]');
    if (this.stzMore) this.stzMoreHtml = this.stzMore.innerHTML;
    if (this.stzMore && this.stzSheet && this.stzSheet.showModal) {
      this.stzMore.addEventListener('click', function () { self.stzSheet.showModal(); });
      this.stzSheet.querySelector('[data-berk-stz-close]').addEventListener('click', function () { self.stzSheet.close(); });
      this.stzSheet.addEventListener('click', function (e) { if (e.target === self.stzSheet) self.stzSheet.close(); });
      this.stzSheet.querySelectorAll('[data-berk-stz-pick]').forEach(function (b) {
        b.addEventListener('click', function () {
          self.weeks = parseInt(b.getAttribute('data-berk-stz-pick'), 10) || 0;
          self.stzEl.querySelectorAll('input[name="berk-weeks"]').forEach(function (r) { r.checked = false; });
          self.stzSheet.close();
          self.update();
        });
      });
    }
  };

  /* ---------- Anzeige aktualisieren ---------- */
  BerkPdp.prototype.update = function () {
    var v = this.variant(), q = this.qty(), stz = this.stzVariant();
    var weeks = stz ? this.weeks : 0;
    var total = v.price * q + (weeks ? weeks * stz.price * q : 0); /* Standzeit-Verlängerung je Container */
    var set = function (sel, txt) { var el = this.root.querySelector(sel); if (el) el.textContent = txt; }.bind(this);

    var priceEl = this.root.querySelector('[data-berk-price]');
    if (priceEl) {
      priceEl.innerHTML = '';
      priceEl.appendChild(document.createTextNode(money(v.price)));
      if (v.compare > v.price) { var s = document.createElement('s'); s.textContent = money(v.compare); priceEl.appendChild(s); }
    }
    if (this.d.taxable) set('[data-berk-vat]', money(Math.round(v.price / 1.19)) + ' netto');
    set('[data-berk-total]', money(total));

    var atc = this.root.querySelector('[data-berk-atc]');
    if (atc) {
      atc.disabled = !v.available;
      set('[data-berk-atc-label]', v.available ? 'In den Warenkorb' : 'Nicht verfügbar');
    }

    if (stz && this.stzEl) {
      this.stzEl.querySelectorAll('[data-berk-wprice]').forEach(function (el) {
        var w = parseInt(el.getAttribute('data-berk-wprice'), 10);
        el.textContent = w === 0 ? 'inklusive' : '+' + money(w * stz.price).replace(',00', '');
      });
      if (this.stzMore) {
        var big = weeks > 3;
        this.stzMore.setAttribute('aria-pressed', big ? 'true' : 'false');
        this.stzMore.innerHTML = big
          ? '<span class="berk-chip__v">' + (7 + 7 * weeks) + ' Tage</span><span class="berk-chip__p">+' + money(weeks * stz.price).replace(',00', '') + '</span>'
          : this.stzMoreHtml;
      }
      this.stzEl.querySelectorAll('[data-berk-stz-pick]').forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-berk-stz-pick'), 10) === weeks ? 'true' : 'false'); });
      set('[data-berk-stz-aux]', weeks ? 'Verlängerung +' + money(weeks * stz.price) + (q > 1 ? ' je Container' : '') : '7 Tage inklusive');
    }

    if (this.d.needsDate && this.dateAux) {
      this.dateAux.classList.toggle('is-err', !!this.dateError);
      this.dateAux.classList.toggle('is-ok', !this.dateError && !!this.dateValue);
      this.dateAux.textContent = this.dateError ? 'Bitte Termin wählen'
        : (this.dateValue ? WD[this.dateValue.getDay()] + ', ' + dmy(this.dateValue) : 'Mo–Fr · Pflichtfeld');
      this.chipsEl.classList.toggle('is-err', !!this.dateError);
    }

    if (this.d.needsDate && this.dateError) {
      this.msg('Bitte wählen Sie zuerst einen Wunschliefertermin.', 'err');
    } else if (q > 1 || weeks) {
      this.msg((q > 1 ? q + ' × ' : '') + money(v.price) + (weeks ? ' + Standzeit ' + (7 + 7 * weeks) + ' Tage (' + (q > 1 ? q + ' × ' : '') + money(weeks * stz.price) + ')' : ''), 'info');
    } else {
      this.msg('', '');
    }
    var minus = this.root.querySelector('[data-berk-qty-step="-1"]');
    if (minus) minus.disabled = q <= 1;
  };
  BerkPdp.prototype.msg = function (text, kind) {
    var el = this.root.querySelector('[data-berk-msg]');
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
    el.className = 'berk-msg' + (kind ? ' is-' + kind : '');
  };

  /* ---------- In den Warenkorb ---------- */
  BerkPdp.prototype.onSubmit = function (e) {
    e.preventDefault();
    if (this.busy) return;
    if (this.d.needsDate && !this.dateValue) {
      this.dateError = true;
      this.update();
      if (this.dateWrap) {
        this.dateWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = this.chipsEl.querySelector('button');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      }
      return;
    }
    this.add();
  };
  BerkPdp.prototype.add = function () {
    var self = this, v = this.variant(), stz = this.stzVariant();
    var props = {};
    if (this.d.needsDate) props['Wunschtermin'] = dmy(this.dateValue);
    var items = [{ id: v.id, quantity: this.qty(), properties: props }];
    if (stz && this.weeks > 0) {
      /* Menge = Wochen × Container; Zuordnung inkl. Wunschtermin, damit mehrere Termine eindeutig bleiben */
      items.push({ id: stz.id, quantity: this.weeks * this.qty(), properties: { 'Für Container': this.d.title + ' – ' + v.title + (props['Wunschtermin'] ? ' – Wunschtermin ' + props['Wunschtermin'] : ''), 'Wochen je Container': String(this.weeks) } });
    }
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      if (window.location.pathname.charAt(0) === '/') body.sections_url = window.location.pathname;
    }
    var atc = this.root.querySelector('[data-berk-atc]');
    this.busy = true;
    if (atc) atc.setAttribute('aria-busy', 'true');
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          self.msg(res.j.description || res.j.message || (typeof res.j.errors === 'string' ? res.j.errors : '') || 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.', 'err');
          return;
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: v.id, cartData: res.j });
        }
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.j);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { self.msg('Keine Verbindung. Bitte versuchen Sie es erneut.', 'err'); })
      .finally(function () { self.busy = false; if (atc) atc.removeAttribute('aria-busy'); });
  };

  /* Cookie-Symbol (Pandectes) mobil über die Kaufleiste schieben und ausblenden, solange der Kaufbereich sichtbar ist */
  function liftCookieWidget() {
    var tries = 0;
    (function tick() {
      var host = document.querySelector('pandectes-cmp');
      if (host && host.shadowRoot) {
        if (!host.shadowRoot.querySelector('#berk-cmp-lift')) {
          var st = document.createElement('style');
          st.id = 'berk-cmp-lift';
          st.textContent = '@media (max-width:749px){.widget.bottom{bottom:calc(96px + env(safe-area-inset-bottom)) !important;transition:opacity .2s}' +
            ':host([data-berk-hide]) .widget.bottom{opacity:0 !important;pointer-events:none !important}}';
          host.shadowRoot.appendChild(st);
          var form = document.querySelector('[data-berk-pdp] form');
          if (form && window.IntersectionObserver) {
            new IntersectionObserver(function (es) { host.toggleAttribute('data-berk-hide', es[0].isIntersecting); }).observe(form);
          }
        }
        return;
      }
      if (tries++ < 24) setTimeout(tick, 500);
    })();
  }

  function boot() {
    document.querySelectorAll('[data-berk-pdp]').forEach(function (el) {
      if (!el.__berk) el.__berk = new BerkPdp(el);
    });
    if (document.querySelector('[data-berk-bar]')) liftCookieWidget();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
